var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.page.blocks)?_c('grid',{key:_vm.page.pageID,attrs:{"blocks":_vm.page.blocks,"editable":false},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var boundingRect = ref.boundingRect;
var block = ref.block;
var index = ref.index;
return [_c('page-block',_vm._g(_vm._b({},'page-block',Object.assign({}, _vm.$attrs, {block: block, page: _vm.page, boundingRect: boundingRect, blockIndex: index}),false),_vm.$listeners))]}}],null,false,2388153024)}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }